import React from 'react'
import { getSvgIconUrl } from '../../parameters'
import { hexToCssFilter, hexToRgb } from '../utils/css'
import { useHover } from '../utils/hover'
import s from './ScrollListWithTitleItem.less'
import TagActionButton from './TagActionButton'

const InnerContent = ({ iconId, logoUrl, label, primaryColor, filter, isHovered }) => {
  return (
    <>
      {logoUrl ? (
        <img src={logoUrl} className={s.logo} alt="" />
      ) : (
        <span
          className={s.iconContainer}
          style={{
            borderColor: hexToRgb(primaryColor, 0.5),
          }}
          width={26}
          height={26}
        >
          <img
            className={s.icon}
            src={getSvgIconUrl(global.__SVG_TIMESTAMP__, iconId)}
            style={{ filter }}
            alt=""
            width={26}
            height={26}
          />
        </span>
      )}

      <span className={s.label} style={{ color: isHovered && primaryColor }}>
        {label}
      </span>
    </>
  )
}

const ScrollListWithTitleItem = ({ iconId, logoUrl, label, onClick, primaryColor, tagProps }) => {
  const [hoverRef, isHovered] = useHover()

  if (!iconId && !logoUrl) return <></>

  const filter = !logoUrl && hexToCssFilter(primaryColor)

  if (tagProps) {
    return (
      <TagActionButton className={s.container} onClick={onClick} elementRef={hoverRef} {...tagProps}>
        <InnerContent {...{ iconId, logoUrl, label, onClick, primaryColor, filter, isHovered }} />
      </TagActionButton>
    )
  }
  return (
    <button className={s.container} onClick={onClick} ref={hoverRef}>
      <InnerContent {...{ iconId, logoUrl, label, onClick, primaryColor, filter, isHovered }} />
    </button>
  )
}

export default ScrollListWithTitleItem
